// Responsible for refreshing access and refresh tokens. The main API client cannot be
// used. It interprets 401 errors as expired sessions and triggers a refresh. If the
// refresh also produces a 401 (e.g. an expired, revoked, or reused refresh token), the
// refresh process would repeat indefinitely.

import axios from 'axios';

const CSRF_HEADER = 'X-CSRF-Refresh';

const getCSRFToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

const csrfInterceptor = [
  (config) => {
    config.headers[CSRF_HEADER] = getCSRFToken() ?? '';

    return config;
  },
  (error) => Promise.reject(error),
  { synchronous: true },
];

const axiosInstance = axios.create({ withCredentials: true });

axiosInstance.interceptors.request.use(...csrfInterceptor);

export default axiosInstance;
